import * as React from 'react';
import { Container, Singleton } from 'typescript-ioc/es5';
import { AppService } from './app';
import {
    axiosFetch,
    isAxiosCancellation,
} from '../config/axios-setup';
import { simpleNotification } from '../_utils/utils';
import aqe from '@pushly/aqe';
import { ServiceApiResponse, ApiCallOptions } from '@pushly/aquarium-utils/lib/react';

@Singleton
export class DictionaryService {

    private appService: AppService;

    public constructor() {
        this.appService = Container.get(AppService);
    }

    public get baseEndpoint(): string {
        return `${aqe.defaults.publicApiDomain}/dictionary`;
    }

    public async fetchLanguageCodes(
        opts: ApiCallOptions = {},
    ): Promise<ServiceApiResponse<any[]>> {
        let ok = false;
        let data: any[] = [];
        let meta: any = {};
        let cancelled = false;
        let error;

        if (opts.showLoadingScreen) { this.appService.setModuleLoading(); }

        try {
            const res = await axiosFetch('get', {
                url: `${this.baseEndpoint}/language-codes`,
            }, opts.cancellationKey);

            const { data: codes, ...resMeta } = res.data;

            ok = true;
            data = codes;
            meta = resMeta;
        } catch (err) {
            error = err;

            if (isAxiosCancellation(err)) {
                cancelled = true;
            } else if (!!err?.response?.data?.message) {
                simpleNotification('error', err.response.data.message);
            }
        }

        if (opts.showLoadingScreen) { this.appService.unsetModuleLoading(); }

        return { ok, data, meta, cancelled, error };
    }

}
